module.exports = {
      id: "certificate-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#certificate-usage",
      toString: function () {
        return this.url;
      }
    }